module.exports = __webpack_public_path__ + "img/AMWETCarousel_upperBack.ee47dbf0.jpg";